// import Logo from './ncdc.png';
import Folder from './folder.svg';
import illustration from './illustration.svg';
import LoginImage from './login-image.jpeg';
import LogoSm from './logo-sm.png';
import Logo from './logo.svg';
import Ncdc from './ncdc.png';
import PDF from './pdficon.svg';
import SpiralImage from './spiral.svg';
import Word from './wordicon.svg';
import Xlsx from './xlsx.svg';

const AppImages = {
  Logo,
  LogoSm,
  LoginImage,
  SpiralImage,
  Folder,
  Word,
  PDF,
  Xlsx,
  illustration,
  NCDCLogo: Ncdc,
};

export default AppImages;
